import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputModule } from './input/input.module';
import { FormFieldModule } from './form-field/form-field.module';
import { PasswordModule } from './password/password.module';
import { SelectModule } from './select/select.module';
import { DateModule } from './date/date.module';
import { InputMaskModule } from './input-mask/input-mask.module';
import { FormFieldInputModule } from './form-field-input/form-field-input.module';
import { FormFieldPasswordModule } from './form-field-password/form-field-password.module';
import { FormFieldSelectModule } from './form-field-select/form-field-select.module';
import { FormFieldInputMaskModule } from './form-field-input-mask/form-field-input-mask.module';
import { FormFieldDateModule } from './form-field-date/form-field-date.module';
import { FormFieldTextareaModule } from './form-field-textarea/form-field-textarea.module';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    InputModule,
    InputMaskModule,
    FormFieldModule,
    PasswordModule,
    SelectModule,
    DateModule,
    FormFieldInputModule,
    FormFieldPasswordModule,
    FormFieldSelectModule,
    FormFieldInputMaskModule,
    FormFieldDateModule,
    FormFieldTextareaModule
  ],
  exports: [
    InputModule,
    InputMaskModule,
    FormFieldModule,
    PasswordModule,
    SelectModule,
    DateModule,
    FormFieldInputModule,
    FormFieldPasswordModule,
    FormFieldSelectModule,
    FormFieldInputMaskModule,
    FormFieldDateModule,
    FormFieldTextareaModule
  ]
})
export class ControlsModule { }
